var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#a0b1c4;}")),React.createElement("g",{"transform":"translate(0 -4)","key":1},[React.createElement("path",{"className":"a","d":"M23,13H1a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z","key":0}),React.createElement("path",{"className":"a","d":"M23,6H1A.945.945,0,0,1,0,5,.945.945,0,0,1,1,4H23a.945.945,0,0,1,1,1A.945.945,0,0,1,23,6Z","key":1}),React.createElement("path",{"className":"a","d":"M23,20H1a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z","key":2})])]);
}

Menu.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = Menu;

Menu.default = Menu;
